import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import './style.css';
// @mui
import { Link, Stack, Button, InputAdornment, TextField, Checkbox, Typography, Divider, Modal, Box } from '@mui/material';
import { LoadingButton } from '@mui/lab';
// components
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Iconify from '../../../components/iconify';
import { Api } from '../../../webservices';
import { userdetail } from '../../../redux/slice/userSlice';
 
// ----------------------------------------------------------------------

export default function LoginForm(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { func } = props;
  const [showPassword, setShowPassword] = useState(false);
  const [value, setValue] = useState({ email: '', pass: '', role: '' });

  const [modalMsg, setModalMsg] = useState('')
   const [loginModal, setLoginModal] = useState(false);
    const closeLoginModal = () => setLoginModal(false);
    const openLoginModal = (msg) => 
    {
      setModalMsg(msg)
      setLoginModal(true);
    }

    const activeInaCompanies = () => {
      const token = localStorage.getItem('token');
      Api('company/activeInactive', 'GET', '', token)
        .then((response) => {
          if (response.status === 200 || response.data.code === 200) {
            //  toast.success("succ")
          } else { 
            //  toast.error("err")
          }
        })
        .catch((err) => {
          // console.error(err);
        });
    };

    const checkEmailVerify = () => {
      const token = localStorage.getItem('token');
      Api('email/chekcSesIdentityVerification', 'GET', '', token)
        .then((response) => {
          if (response.status === 200 || response.data.code === 200) {
            //  toast.success("Email send successfully.")
          } else { 
        // toast.error("err", response.resmessage)
          }
        })
        .catch((err) => {
          // console.error(err);
        });
    };
 
  const logIn = async (e) => {
    activeInaCompanies()
  
    localStorage.removeItem('sign');
    localStorage.removeItem('token');
    localStorage.removeItem('userid');
    localStorage.removeItem('role');
    localStorage.removeItem('name');
    localStorage.removeItem('recRole');
    localStorage.removeItem('recId');
    // alert('ashish')
    e.preventDefault();
    const body = {
      email: value.email,
      password: value.pass,
      // "role": value.role
    };
    Api(`company/company_login`, 'POST', body, '')
      .then((response) => {
        // console.log('==========login=====>>>>>>>', JSON.stringify(response.data.data));
        if (response.status === 200) {
          if (response.data.data) {

            dispatch(userdetail(response.data.data));
            localStorage.setItem('typeUser', response.data?.data?.typeUser);
            
              localStorage.setItem('recRole', response.data?.data?.role);
              localStorage.setItem('recId', response.data?.data?._id);
            // toast.success(response.data.message);
            if (response.data.data.role === 'superadmin') {
              // navigate('/usermanagement', { replace: true });
              navigate('/addCompany', { replace: true });
            }
              else if (response.data.data.typeUser === "individual") {
                navigate(
                  // '/management',
                  '/worksheet',
                  { state: {  } },
                  { replace: true }
                );
                localStorage.setItem("dash", "dash");
              }

             else if (response.data.data.role === 'admin') {
              navigate(
                // '/management',
                '/app',
                { state: { id: response.data.data._id, rolee: response.data.data.role } },
                { replace: true }
              );
            } 
            else if (response.data.data.role === 'recruiterHead') {
              navigate('/worksheet' );
              // navigate(
              //   '/recuiterManager',
              //   { state: { id: response.data.data._id, rolee: response.data.data.role } },
              //   { replace: true }
              // );
            } else if (response.data.data.role === 'salesHead') {
              navigate(
                // '/salesManager',
                '/salesworksheet',
                { state: { id: response.data.data._id, rolee: response.data.data.role } },
                { replace: true }
              );
            } else if (response.data.data.role === 'recruiterManager') {
              navigate('/worksheet' );
              // navigate(
              //   '/recruiterTeamLead',
              //   { state: { id: response.data.data._id, rolee: response.data.data.role } },
              //   { replace: true }
              // );
            } else if (response.data.data.role === 'salesManager') {
              navigate(
                // '/salesTeamLead',
                '/salesworksheet',
                { state: { id: response.data.data._id, rolee: response.data.data.role } },
                { replace: true }
              );
            } else if (response.data.data.role === 'salesExecutive') {
              navigate(
                '/salesworksheet',
                { state: { id: response.data.data._id, rolee: response.data.data.role } },
                { replace: true }
              );
            } else if (response.data.data.role === 'recruiter') {
              navigate(
                '/worksheet',
                // { state: { id: response.data.data._id, rolee: response.data.data.role } },
                { replace: true }
              );
            } else if (response.data.data.role === 'recruiterTrainee') {
              navigate(
                '/worksheet',
                // { state: { id: response.data.data._id, rolee: response.data.data.role } },
                { replace: true }
              );
            } else if (response.data.data.role === 'salesTrainee') {
              navigate(
                '/salesworksheet',
                { state: { id: response.data.data._id, rolee: response.data.data.role } },
                { replace: true }
              );
            } else if (response.data.data.role === 'recruiterTeamLead') {
              // navigate('/recruiterManagement', { state: { id: response.data.data._id } });
              navigate('/worksheet' );
            } else if (response.data.data.role === 'salesTeamLead') {
              navigate(
                // '/salesManagement',
                '/salesworksheet',
                 { state: { id: response.data.data._id } });
            }
             else if (response.data.data.role === 'benchSalesHead' || response.data.data.role === 'benchSalesManager' ||
              response.data.data.role === 'benchSalesTeamLead' || response.data.data.role === 'benchSalesExecutive'
             ) {
              navigate(
               
                '/benchworksheet',
                //  { state: { id: response.data.data._id } });
                 { replace: true }
              )
            }
            localStorage.setItem('token', response.data.token);
            localStorage.setItem('userid', response.data.data._id);
            localStorage.setItem('role', response.data.data.role);
            localStorage.setItem('userType', response.data.data.userType);
            localStorage.setItem('username', response.data.data.contactPersonName);
            localStorage.setItem('email', response.data.data.email);
            // alert(response.data.data.role)
            localStorage.setItem('name', response.data.data.companyName);
            localStorage.setItem('image', response.data?.data?.profileImage);
            localStorage.setItem('companyName', response.data?.data?.companyName);
            localStorage.setItem('companyLogo', response.data?.data?.companyLogo);
            // window.location.reload()
              checkEmailVerify()
          }
          else{
            // openLoginModal(response.data.reason || response.data.resmessage || response.data.message)
            toast.warn(response.data.reason, +'!');
            toast.warn(response.data.resmessage, +'!');
            toast.warn(response.data.message, +'!');
           
          }
        } else {
          // openLoginModal(response.data.reason || response.data.resmessage || response.data.message)
           
          toast.warn(response.data.reason, +'!');
          toast.warn(response.data.resmessage, +'!');
          toast.warn(response.data.message, +'!');
         
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        toast.warn(err);
      });
  };

  const styleLoading = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    // width: { xs: '95%', sm: '70%' },
    // width: { xs: '85%', sm: '60%' },
    bgcolor: 'background.paper',
    border: '3px solid #3C6BA5',
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
  };

  return (
    <>
    <Modal open={loginModal} onClose={closeLoginModal} style={{ borderRadius: 10 }}>
        <Box sx={[styleLoading]}>
          <Stack sx={{ justifyContent: "center", alignContent: 'center', width: '100%' }}>
            <Stack sx={{ width: "100%" }}>
              <Typography sx={{}} variant='h6' textAlign={"center"} color={'red'}>
                {modalMsg}
                
              </Typography>
            </Stack>
           
          </Stack>

        </Box>  
      </Modal>

    {/* <Stack sx={{flexDirection:'row',justifyContent:'flex-end',mb:1}}>
    <Typography variant="subtitle1" >
    Contact Sales :&nbsp;
  </Typography>
    <Typography color="#e3398b" variant="subtitle1">
     (386) 465 2764
  </Typography>
  </Stack> */}
    <Stack bgcolor={'white'} sx={{p:3}} border={'2px solid #3C6BA5'} borderRadius={3}>
      <ToastContainer />
      <Typography variant="h5" sx={{color:'text.secondary',px:5,fontWeight:'600'}}  gutterBottom mb={4} >
        Welcome to Foxearch
      </Typography>
      <Stack spacing={2} className="email_field" >
        <input
          label="User Name"
          color="secondary"
          placeholder="User Name"
          onChange={(e) => setValue({ ...value, email: e.target.value })}
        />
        <Stack className="passwordIcon">
          <input
            label="Password"
            color="secondary"
            placeholder="Password"
            type={showPassword ? 'text' : 'password'}
            onChange={(e) => setValue({ ...value, pass: e.target.value })}
          />
          <Iconify
            icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'}
            onClick={() => setShowPassword(!showPassword)}
          />
        </Stack>
        <Typography
            sx={{ letterSpacing: '1.25px', cursor: 'pointer',marginLeft:'2px !important' }}
            color="#e3398b"
            variant="subtitle2"
            onClick={func}
          >
            FORGOT PASSWORD?
          </Typography>
        <Stack alignItems={'center'}>
          <button className="login_btn" onClick={(e) => logIn(e)}>
            LOGIN
          </button> 
        </Stack>
      </Stack>

      {/* <LoadingButton fullWidth size="large" type="submit" variant="contained" onClick={(e)=>logIn(e)}>
        Login
      </LoadingButton> */}
    </Stack>
    <Stack sx={{flexDirection:'row', marginTop:'8px', marginLeft:'5px'}}>
      {/* <Typography variant="subtitle2">New to Foxearch ?&nbsp;</Typography> */}
      <Typography variant="subtitle2">Individual User ?&nbsp;</Typography>
      <Typography color="#e3398b" sx={{cursor:"pointer"}}
            variant="subtitle2" onClick={()=>navigate('/signup')}>Signup Free</Typography>
    </Stack>
    {/* <Button variant="contained"  className="newacc_btn">
        CREATE NEW ACCOUNT
      </Button> */}

<Stack sx={{flexDirection:'row',justifyContent:'flex-start',marginLeft:'5px'}}>
    <Typography variant="subtitle2" >
    An Enterprise ?  &nbsp;
  </Typography>
    <Typography color="#e3398b" variant="subtitle2">
    Contact Sales (386) 465 2764
  </Typography>
  </Stack>

    </>
  );
}
